<app-component-card title="Input Group">
  <div class="space-y-6">
    <div>
      <app-label>Email</app-label>
      <div class="relative">
        <span class="absolute left-0 top-1/2 -translate-y-1/2 border-r border-gray-200 px-3.5 py-3 text-gray-500 dark:border-gray-800 dark:text-gray-400">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.04175 7.06206V14.375C3.04175 14.6511 3.26561 14.875 3.54175 14.875H16.4584C16.7346 14.875 16.9584 14.6511 16.9584 14.375V7.06245L11.1443 11.1168C10.457 11.5961 9.54373 11.5961 8.85638 11.1168L3.04175 7.06206ZM16.9584 5.19262C16.9584 5.19341 16.9584 5.1942 16.9584 5.19498V5.20026C16.9572 5.22216 16.946 5.24239 16.9279 5.25501L10.2864 9.88638C10.1145 10.0062 9.8862 10.0062 9.71437 9.88638L3.07255 5.25485C3.05342 5.24151 3.04202 5.21967 3.04202 5.19636C3.042 5.15695 3.07394 5.125 3.11335 5.125H16.8871C16.9253 5.125 16.9564 5.15494 16.9584 5.19262ZM18.4584 5.21428V14.375C18.4584 15.4796 17.563 16.375 16.4584 16.375H3.54175C2.43718 16.375 1.54175 15.4796 1.54175 14.375V5.19498C1.54175 5.1852 1.54194 5.17546 1.54231 5.16577C1.55858 4.31209 2.25571 3.625 3.11335 3.625H16.8871C17.7549 3.625 18.4584 4.32843 18.4585 5.19622C18.4585 5.20225 18.4585 5.20826 18.4584 5.21428Z" fill="#667085"></path></svg>
        </span>
        <app-input-field
          placeholder="info@gmail.com"
          type="text"
          className="pl-[62px]"
        />
      </div>
    </div>
    <div>
      <app-label>Phone</app-label>
      <app-phone-input
        [selectPosition]="'start'"
        [countries]="countries"
        placeholder="+1 (555) 000-0000"
        (phoneChange)="handlePhoneNumberChange($event)"
      />
    </div>
    <div>
      <app-label>Phone</app-label>
      <app-phone-input
        [selectPosition]="'end'"
        [countries]="countries"
         placeholder="+1 (555) 000-0000"
        (phoneChange)="handlePhoneNumberChange($event)"
      />
    </div>
  </div>
</app-component-card>